export interface GroupList {
  id: string | number;
  title: string;
  subtitle: string;
  dateAdded: string;
  followers: number;
}

export enum EditGroupTypes {
  editGroupInformation = 'Edit group information',
  editExperts = 'Edit experts',
  editSessions = 'Edit sessions',
  editContent = 'Edit content',
  editArticles = 'Edit articles',
}

export enum EditGroupGroupsType {
  public = 'public',
  private = 'private',
  subscription = 'subscription',
}

const API = {
  GET_GROUPS: {
    path: '/group/details/expert',
    method: 'GET',
  },
  UPDATE_GROUPS: {
    path: '/group/expert/update',
    method: 'POST',
  },
  POST_UPDATE_GROUP_USER: {
    path: '/group/user/update',
    method: 'POST',
  },
  GET_FETCH_EXPERTS: {
    path: '/expert/search',
    method: 'GET',
  },
  GET_GROUP_SUMMARY: {
    path: '/group/details',
    method: 'GET',
  },
  DELETE_GROUP: {
    path: '/group/expert/delete',
    method: 'POST',
  },
};
export default API;
